import React, { useState, useEffect } from "react";
import scrollToTop from "../components/ScrollTo";
import { slides } from "../data/slideData";
import Header from "../components/Header-2";
import ImgMasonry from "../components/Masonry";
import { IKImage, IKContext } from "imagekitio-react";

export default function Index() {
  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const images = [
    "/portraits/Stephen-2017-02_XWcThIBhU.webp",
    "/portraits/david_Gsix8W.webp",
    "/portraits/_brianne_6uwT9yJmk_UJOLEmkps.webp",
    "/portraits/Jonathan_8390602582_5HiFtdFon.webp",
    "/portraits/_DSC7495_fkorC_PVC_L9U7tfXMw.webp",
    "/portraits/Tyjay_ok4sGzKi0.webp",
    "/portraits/TRI5548_fEuqIjb.webp",
    "/portraits/stranger-1_YsqGfYdbZ.webp",
    "/portraits/Canadian-Tire-PitStop_8nIjK55CH.JPG?updatedAt=1722159711773",
    "/portraits/_DSC6405-1_r5hByMsJw.webp",
    "/portraits/David-2017-08_A2Y8pGEIs.webp",
    "/portraits/DSC_2607_LcpCohPDJ.webp",
    "/portraits/walter_r2_vMOt5w.webp",
    "/portraits/isaa_DSC6089_JZJlkwSQ2.webp",
    "/portraits/T4002_8557497835_efRo0cS_P.webp",
    "/portraits/Brazil-2014-1_DID0DAWJI.webp",
    "/portraits/Suits-2_jFEmOGN3A.webp",
    "/portraits/wedding_OMz1ItZBc.webp",
    "/portraits/wedding_DSC3871_l3SiwGpyy.webp",
    "/portraits/wedding_DjM.webp",
    "/portraits/JON_El0ri7CWe.webp",
    "/portraits/DSC_3166-2_9ei0MralE.webp",
    "/portraits/_DSC6598_IIO4Zb2ug.webp",
    "/portraits/JOR_NbNH6IKRr.webp",
  ];

  return (
    <main id="top" className="bg-[#f4f2f2] dark:bg-[#201c1c] text-[#252525]">
      <div className="dark:bg-[#201c1c]">
        <Header />
        <ImgMasonry images={images} />
      </div>
    </main>
  );
}
